import React from 'react'
import virtual_business_frontend from "../../Assets/virtual-business-frontend.vercel.app_screenshot.png"
import virtual_academy from "../../Assets/virtual_academy_screenshot.png"
import digress_appointments from "../../Assets/main.d3ki3n88opz9zp.amplifyapp.com_.png"
import nexus_gk_real_estate from "../../Assets/nexusgk-real-estate-rho.vercel.app_ (1).png"
import system_analysis_kenya from "../../Assets/system-analysis-kenya.vercel.app_ (1).png"
function MyPortiflio() {
    const Projects=[
        {
       "id": 1,
      "src": virtual_business_frontend,
      "title": "Virtual-Business-App",
      "description": "Experience world class business management through communication and transactions with reduced costs and improved profits",      
      "livelink":"https://virtual-business-frontend.vercel.app/"   ,
     
      
    },
    {
        "id": 2,
       "src": virtual_academy,
       "title": "Virtual-Academy",
       "description": "Experience world class education with enhanced comuncication and user friendliness with step by step format to ensure clarity and engagement",       
      "livelink":"https://virtulearn.onrender.com",
      
               
     },
     {
        "id": 3,
       "src": digress_appointments,
       "title": "Digress Appointments",
       "description": "Experience the future of healthcare scheduling with Digress Appointments. Our innovative platform connects doctors and patients, providing an effortless way to book, manage, and track appointments.",
      
      "livelink":"https://main.d3ki3n88opz9zp.amplifyapp.com/",
       
              
     },
     {
        "id": 4,
       "src": nexus_gk_real_estate,
       "title": "RealtlyNest",
       "description": "Experience the future of Real Estatemanagement through our enhanced user interface, historic listing and a fast,reliable database to improve our experience and  lead in property management",       
      "livelink":"https://nexusgk-real-estate-rho.vercel.app/",
       
              
     },
     {
        "id": 5,
       "src": system_analysis_kenya,
       "title": "System Analysis",
       "description": "Experience the future of Research management through our enhanced user interface, research analysis  and a fast,reliable database to improve our experience and  lead in research management",       
      "livelink":"https://system-analysis-kenya.vercel.app/",
       
              
     },
    
]
  return (
    <section className="portfolio--section" id="MyPortifolio">
      <div className="portfolio--container-box">
        <div className="portfolio--container">
          <p className="sub--title">Recent Projects</p>
          <h2 className="section--heading">My Portfolio</h2>
        </div>
        <div>
          <button className="btn bg-blue-500">
            <a href='https://github.com/estherwanjiku007'>Visit My GitHub</a>
            
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 space-">
        {Projects.map((item, index) => (
          <div key={index} className="portfolio--section--card p-4 rounded-lg shadow-md hover:scale-105">
            <div className="portfolio--section--img">
              <img src={item.src} alt="Placeholder" className='w-full h-[350px] rounded-lg' />
            </div>
            <div className="portfolio--section--card--content">
              <div>
                <h3 className="portfolio--section--title text-meium font-bold ">{item.title}</h3>
                <p className="text-md">{item.description}</p>
              </div>
              <div className='projects-live-link'>
                <div>                
                <a href={`${item.livelink}`} className=' text-blue-500'> Live Link</a>
                </div>
               
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
  


export default MyPortiflio